module.exports = __webpack_public_path__ + "static/img/yytx17.962e418.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx17.png
// module id = 797
// module chunks = 0